import React, { useState, forwardRef, useEffect } from 'react'
import CheckCircleOutlineSharpIcon from '@mui/icons-material/CheckCircleOutlineSharp'
import HighlightOffSharpIcon from '@mui/icons-material/HighlightOffSharp'
import ErrorOutlineSharpIcon from '@mui/icons-material/ErrorOutlineSharp'
import { East, Close, ArrowDropDown } from '@mui/icons-material'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Menu,
  Button,
  Tooltip,
  IconButton,
  Slide,
  MenuItem,
  CircularProgress
} from '@mui/material'
import MoreVertIcon from '@mui/icons-material/MoreVert'

const Transition = forwardRef(function Transition (props, ref) {
  return <Slide direction='left' ref={ref} {...props} />
})

function AnalysisCard ({ cardData, cardType, selectedLob }) {
  const [openPopup, setOpenPopup] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const [actionTaken, setActionTaken] = useState(null)
  const [appetiteInfo, setAppetiteInfo] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [borderColor, setBorderColor] = useState('gray')
  const open = Boolean(anchorEl)

  const handleClose = () => {
    setAnchorEl(null)
  }
  const handleIconClick = () => {
    setOpenPopup(true)
  }

  const handleClosePopup = () => {
    setOpenPopup(false)
    setActionTaken('')
  }

  const handleMenuClick = event => {
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setAnchorEl(null)
  }

  const handleActionClick = action => {
    setActionTaken(action)
    handleMenuClose()
  }

  useEffect(() => {
    setIsLoading(true)
    if (cardData) {
      setTimeout(() => {
        setAppetiteInfo(cardData)
      }, 1000)
    } else {
      setAppetiteInfo({})
    }
    setTimeout(() => {
      setIsLoading(false)
    }, 1000)

    if (cardType === 'Do Not Write' && cardData?.Summary?.score) {
      setBorderColor(cardData?.Summary?.score === 10 ? 'green' : 'red')
    } else {
      if (cardData?.Summary?.score < 5) {
        setBorderColor('red')
      } else if (cardData?.Summary?.score < 7) {
        setBorderColor('orange')
      } else if (cardData?.Summary?.score >= 7) {
        setBorderColor('green')
      }
    }
  }, [cardData, cardType, selectedLob])

  const ProgressCircle = ({ value }) => {
    const percent = (value / 10) * 100

    const radius = 30 // Radius of the circle
    const strokeWidth = 6 // Stroke width
    const normalizedRadius = radius - strokeWidth * 0.5
    const circumference = normalizedRadius * 2 * Math.PI
    const strokeDashoffset = circumference - (percent / 100) * circumference

    // Dynamic color based on percentage
    let strokeColor
    if (percent >= 80) {
      strokeColor = '#00cc00' // Green for >= 75%
    } else if (percent >= 50) {
      strokeColor = '#ff9900' // Yellow for >= 50%
    } else {
      strokeColor = '#ff0000' // Red for < 50%
    }

    return (
      <svg
        height={radius * 2}
        width={radius * 2}
        style={{ filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.1))' }}
      >
        {/* Background Circle */}
        <circle
          stroke='#e6e6e6' // Light grey background
          fill='transparent'
          strokeWidth={strokeWidth}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
        />

        {/* Progress Circle with gradient */}
        <circle
          stroke={strokeColor} // Dynamic stroke color based on percentage
          fill='transparent'
          strokeWidth={strokeWidth}
          r={normalizedRadius}
          cx={radius}
          cy={radius}
          strokeDasharray={circumference + ' ' + circumference}
          strokeDashoffset={strokeDashoffset}
          style={{
            transition: 'stroke-dashoffset 0.5s ease 0s, stroke 0.5s ease',
            strokeLinecap: 'round' // Rounded edges
          }}
        />

        {/* Central Text */}
        <text
          x='50%'
          y='50%'
          textAnchor='middle'
          fill='#000'
          dy='.3em'
          fontSize='1.2em'
          fontWeight='bold'
        >
          {`${value}/${10}`}
        </text>
      </svg>
    )
  }
  return (
    <div className='w-[350px] stage-types'>
      <h2 className='mb-2 text-xl text-center text-black'>{cardType}</h2>
      <div
        className={`flex flex-col p-4 max-w-full text-sm leading-5 rounded-3xl border-b-8 shadow-lg ${borderColor}`}
        style={{
          border: '1px solid gray',
          borderBottom: `5px solid ${borderColor}`
        }}
      >
        {cardType === 'Do Not Write' && cardData?.Summary?.score < 10 ? (
          <div className='flex justify-center items-center self-end px-0.5 w-5 h-5 min-h-[20px] rounded-[64px] max-md:mr-2.5 shadow-md'>
            <HighlightOffSharpIcon className='status-stop' />
          </div>
        ) : cardData?.Summary?.score >= 8 ? (
          <div className='flex justify-center items-center self-end px-0.5 w-5 h-5 min-h-[20px] rounded-[64px] max-md:mr-2.5 shadow-md'>
            <CheckCircleOutlineSharpIcon className='status-green' />
          </div>
        ) : cardData?.Summary?.score >= 5 ? (
          <div className='flex justify-center items-center self-end px-0.5 w-5 h-5 min-h-[20px] rounded-[64px] max-md:mr-2.5 shadow-md'>
            <ErrorOutlineSharpIcon className='status-inprogress' />
          </div>
        ) : (
          <div className='flex justify-center items-center self-end px-0.5 w-5 h-5 min-h-[20px] rounded-[64px] max-md:mr-2.5 shadow-md'>
            <HighlightOffSharpIcon className='status-stop' />
          </div>
        )}
        {/* <div className='flex justify-center items-center'>
          <ProgressCircle value={cardData?.score} />
        </div> */}
        <div className='flex flex-col items-start mt-2'>
          <div className='appetite-content'>
            {isLoading ? (
              <div className='flex justify-center items-center w-full h-full p-4'>
                <CircularProgress color='warning' />
              </div>
            ) : (
              appetiteInfo?.Summary?.AppetiteSummary ||
              'No data found for this category'
            )}
          </div>
          <East
            className='text-black self-end cursor-pointer'
            fontSize='medium'
            onClick={handleIconClick}
            style={{ cursor: 'pointer' }}
          />
        </div>
      </div>
      <Dialog
        open={openPopup}
        onClose={handleClosePopup}
        TransitionComponent={Transition}
        fullWidth
        maxWidth='900px'
        PaperProps={{
          style: {
            border: '2px solid #ea580c',
            borderBottom: '5px solid #ea580c',
            boxShadow: '0px 4px 10px rgba(255, 165, 0, 0.4)',
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            margin: 0,
            width: '600px',
            borderRadius: '10px',
            background: 'linear-gradient(to right, #f8f9fa, #e9ecef)'
          }
        }}
      >
        <DialogTitle className='flex justify-between items-center'>
          <span>
            {' '}
            <strong>{cardType} Details</strong>
          </span>
          {appetiteInfo?.['Summary']?.Escalatable && !actionTaken && (
            <div
              className='flex items-center cursor-pointer text-sm font-normal ml-auto'
              onClick={handleMenuClick}
            >
              <span>Action</span>
              <ArrowDropDown />
            </div>
          )}
          {appetiteInfo?.['Summary']?.Escalatable && (
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleMenuClose}
              PaperProps={{
                style: {
                  display: 'flex',
                  flexDirection: 'column'
                }
              }}
            >
              <Tooltip title='Actions' arrow>
                <IconButton onClick={handleMenuClick}>
                  <MoreVertIcon />
                </IconButton>
              </Tooltip>
              <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
                {/* <MenuItem
                onClick={() => handleActionClick('Respond')}
                style={{
                  marginBottom: '5px'
                }}
              >
                Respond
              </MenuItem> */}

                <MenuItem onClick={() => handleActionClick('Escalate')}>
                  Escalate
                </MenuItem>
              </Menu>
            </Menu>
          )}
          <IconButton onClick={handleClosePopup}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <div className='grid grid-cols-1 gap-4'>
            {!actionTaken && Object.keys(appetiteInfo).length > 0 && (
              <>
                <div className='space-y-4'>
                  <h3 className='font-bold'>Appetite Details</h3>
                  <div>
                    {Object.keys(appetiteInfo?.AppetiteDetails || []).map(
                      (category, index) => {
                        const categoryData =
                          appetiteInfo?.AppetiteDetails[category]
                        return (
                          <div key={index} style={{ marginBottom: '20px' }}>
                            {categoryData.Result && (
                              <p>
                                <strong>Result:</strong>{' '}
                                {categoryData.MetNotMet}
                              </p>
                            )}
                            {categoryData.Details && (
                              <p>
                                <strong>Details:</strong> {categoryData.Details}
                              </p>
                            )}
                          </div>
                        )
                      }
                    )}
                  </div>
                </div>
                {/* <div className='space-y-4'>
                  {cardType !== 'Company Analysis' && (
                    <>
                      <h3 className='font-bold'>Appetite References</h3>
                      <div>
                        <ul>
                          {Object.keys(
                            appetiteInfo?.ReferenceDetails || []
                          ).map((referenceKey, index) => {
                            const reference =
                              appetiteInfo?.ReferenceDetails[referenceKey]
                            return (
                              reference && (
                                <li className='mb-5' key={index}>
                                  {reference}
                                </li>
                              )
                            )
                          })}
                        </ul>
                      </div>
                    </>
                  )}

                  {cardType !== 'Company Analysis' && (
                    <div>
                      <ul>
                        {Object.keys(
                          appetiteInfo?.ExternalReferences || []
                        ).map((referenceKey, index) => {
                          const reference =
                            appetiteInfo?.ExternalReferences[referenceKey]
                          return (
                            reference && (
                              <li className='mb-5' key={index}>
                                {reference}
                              </li>
                            )
                          )
                        })}
                      </ul>
                    </div>
                  )}
                </div> */}
              </>
            )}
            {actionTaken === 'Respond' && (
              <>
                <div className=''>
                  <p className='pb-8'>
                    {appetiteInfo?.Summary?.AppetiteSummary}
                  </p>
                  <Button
                    onClick={() => handleClosePopup('Respond')}
                    variant='contained'
                    style={{
                      backgroundColor: 'green',
                      color: 'white',
                      marginBottom: '10px'
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </>
            )}
            {actionTaken === 'Escalate' && (
              <>
                <div className=''>
                  <p className='pb-8'>
                    {appetiteInfo?.Summary?.AppetiteSummary}
                  </p>
                  <Button
                    onClick={() => handleClosePopup('Escalate')}
                    variant='contained'
                    style={{
                      backgroundColor: 'green',
                      color: 'white',
                      marginBottom: '10px'
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default AnalysisCard
